/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterError,
  PresenterResponse,
  PresenterSuggestAssetCategoryRequest,
  PresenterSuggestAssetCategoryResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AssetsSuggestions<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Suggest asset category
   *
   * @tags assets suggestions
   * @name PostAssetsSuggestions
   * @summary Suggest Asset Category
   * @request POST:/assets/suggestions
   */
  postAssetsSuggestions = (
    body: PresenterSuggestAssetCategoryRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSuggestAssetCategoryResponse;
      },
      PresenterError
    >({
      path: `/assets/suggestions`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
